//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { dateFormat, disabledDate } from '@/plugin/format.js'
import PictureList from '@/components/PictureList.vue'
import UploadFile from '../controls/uploadfile.vue'
export default {
  data() {
    return {
      filters: {
        keyword: '',
        status: ''
      },
      dtypes: [],
      dclassifys: [],
      dmodels: [],
      datas: [],
      dataForm: {
        id: '',
        usertype: null,
        company: '',
        address: '',
        contact: '',
        phone: '',
        dtype: '显示器',
        dclassify: '',
        model: '',
        warrantystatus: null,
        seriesno: '',
        invoice: null,
        troubledescription: '',
        annex: null
      },
      pickerOptions: {
        disabledDate(time) {
          return disabledDate(time)
        }
      },
      editDialogVisible: false, // 新增编辑界面是否显示
      pictureVisible: false,
      dataFormRules: {
        usertype: [
          { required: true, message: '请选择用户类别', trigger: 'blur' }
        ],
        company: [
          { required: true, message: '请输入单位名称', trigger: 'blur' }
        ],
        address: [
          { required: true, message: '请输入联系地址', trigger: 'blur' }
        ],
        contact: [
          { required: true, message: '请输入联系人', trigger: 'blur' },
          {
            pattern: /^[\u4E00-\u9FA5]{1,4}(?:·[\u4E00-\u9FA5]{2,4})*$/,

            message: '请输入正确的姓名',
            trigger: 'blur'
          }
        ],
        phone: [
          { required: true, message: '请输入联系电话', trigger: 'blur' },
          {
            pattern: /0\d{2,3}-[1-9]\d{6,7}/,
            message: '请输入正确格式',
            trigger: 'blur'
          }
        ],
        dclassify: [
          { required: true, message: '请输入设备分类', trigger: 'blur' }
        ],
        dtype: [{ required: true, message: '请选择设备种类', trigger: 'blur' }],
        model: [{ required: true, message: '请选择型号', trigger: 'blur' }],
        warrantystatus: [
          { required: true, message: '请选择保修状况', trigger: 'blur' }
        ],
        invoice: [{ required: true, message: '请上传文档', trigger: 'blur' }],
        annex: [{ required: true, message: '请上传相关图片', trigger: 'blur' }],
        troubledescription: [
          { required: true, message: '请输入故障描述', trigger: 'blur' },
          {
            min: 10,
            max: 200,
            message: '故障描述在10到200个字符',
            trigger: 'change'
          }
        ]
      },
      canDeleteList: [],
      picturelist: []
    }
  },
  methods: {
    getlist: function() {
      let un = sessionStorage.getItem('user')
      let params = {
        UserName: un,
        Keyword: this.filters.keyword.trim()
      }
      if (this.filters.status) {
        params.Status = this.filters.status
      }

      this.$api
        .getRepair(params)
        .then(res => {
          if (res.Status === 1) {
            var list = []
            res.Entity.forEach(dev => {
              if (dev.Status === '已报修') dev.StatusId = 1
              if (dev.Status === '已派工') dev.StatusId = 2
              if (dev.Status === '已处理') dev.StatusId = 3
              list.push(dev)
            })
            list.sort((a, b) => a.StatusId - b.StatusId)
            this.datas = list
          } else {
            this.$alert(res.Message, '错误', {
              confirmButtonText: '确定'
            })
          }
        })
        .catch(function(res) {
          this.$alert('获取数据错误！', '错误', {
            confirmButtonText: '确定'
          })
        })
      this.dtypeSelectChanged()
    },
    handleAdd: function() {
      this.editDialogVisible = true
      this.dataForm = {
        usertype: null,
        company: '',
        address: '',
        contact: '',
        phone: '',
        dtype: '显示器',
        dclassify: '',
        model: '',
        warrantystatus: null,
        seriesno: '',
        invoice: null,
        troubledescription: '',
        annex: null
      }
    },
    handleEdit: function(dev) {
      this.editDialogVisible = true
      this.dataForm = {
        id: dev.Id,

        usertype: dev.UserType,
        company: dev.Company,
        address: dev.Address,
        contact: dev.Contact,
        phone: dev.Phone,
        dtype: dev.DType,
        dclassify: dev.DClassify,
        model: dev.Model,
        warrantystatus: dev.WarrantyStatus,
        seriesno: dev.SeriesNO,
        invoice: dev.Invoice,
        troubledescription: dev.TroubleDescription,
        annex: dev.Annex,
        status: dev.Status
      }
    },

    handleDelete: function(device) {
      this.canDeleteList = []
      this.canDeleteList.push(device)
      this.handleDeleteList()
    },
    handleDeleteList: function() {
      this.$confirm(
        '确认删除' +
          this.canDeleteList.length.toString() +
          '台设备进行报修吗？',
        '提示',
        { cancelButtonClass: 'btn-custom-cancel' }
      ).then(() => {
        let ids = []
        this.canDeleteList.forEach(pt => {
          ids.push(pt.Id)
        })
        this.$api.deleteRepair(ids).then(res => {
          if (res.Status === 1) {
            this.$message({ message: '删除成功', type: 'success' })
            this.getlist()
          } else {
            this.$alert(res.Message, '错误', {
              confirmButtonText: '确定'
            })
          }
        })
      })
    },
    handleConfirm: function() {
      this.$refs.dataForm.validate(valid => {
        if (valid) {
          this.$confirm('确认提交吗？', '提示', {
            cancelButtonClass: 'btn-custom-cancel'
          }).then(() => {
            let un = sessionStorage.getItem('user')
            let params = {
              UserName: un,
              UserType: this.dataForm.usertype,
              Company: this.dataForm.company,
              Address: this.dataForm.address,
              Contact: this.dataForm.contact,
              Phone: this.dataForm.phone,
              DType: this.dataForm.dtype,
              DClassify: this.dataForm.dclassify,
              Model: this.dataForm.model,
              WarrantyStatus: this.dataForm.warrantystatus,
              SeriesNO: this.dataForm.seriesno,
              Invoice: this.dataForm.invoice,
              TroubleDescription: this.dataForm.troubledescription,
              Annex: this.dataForm.annex,

              Status: this.dataForm.status
            }
            if (this.dataForm.id !== '') params.Id = this.dataForm.id
            this.$api.saveRepair(params).then(res => {
              if (res.Status === 1) {
                this.$message({ message: '提交成功', type: 'success' })
                this.editDialogVisible = false
                this.getlist()
              } else {
                this.$alert(res.Message, '错误', {
                  confirmButtonText: '确定'
                })
              }
            })
          })
        }
      })
    },
    handleSearch: function() {
      this.getlist()
    },

    handleShowPicture: function(params) {
      this.pictureVisible = true
      this.$api
        .getFile(params)
        .then(res => {
          if (res.Status === 1) {
            var list = []
            res.Entity.forEach(item => {
              list.push('data:image/png;base64,' + item.Contents)
            })
            this.picturelist = list
          } else {
            this.$alert(res.Message, '错误', {
              confirmButtonText: '确定'
            })
          }
        })
        .catch(function(res) {
          this.$alert('获取数据错误！', '错误', {
            confirmButtonText: '确定'
          })
        })
    },
    getDType: function() {
      let params = {}
      this.$api
        .selectDType(params)
        .then(res => {
          if (res.Status === 1) {
            this.dtypes = res.Entity
          } else {
            this.$alert(res.Message, '错误', {
              confirmButtonText: '确定'
            })
          }
        })
        .catch(function(res) {
          alert(res)
        })
    },
    dtypeSelectChanged: function(selVal) {
      let params = { DType: this.dataForm.dtype }

      this.$api
        .selectDClassify(params)
        .then(res => {
          if (res.Status === 1) {
            this.dclassifys = res.Entity
            if (this.dclassifys.indexOf(this.dataForm.dclassify) >= 0) {
            } else {
              this.dataForm.dclassify = ''
              this.dataForm.model = ''
            }
          } else {
            this.$alert(res.Message, '错误', {
              confirmButtonText: '确定'
            })
          }
        })
        .catch(function(res) {
          alert(res)
        })
    },
    dclassifySelectChanged: function(selVal) {
      let params = {
        DClassify: this.dataForm.dclassify,
        DType: this.dataForm.dtype
      }

      console.log('dclassify:' + selVal)
      this.$api
        .selectDModel(params)
        .then(res => {
          if (res.Status === 1) {
            this.dmodels = res.Entity
            if (this.dmodels.indexOf(this.dataForm.model) >= 0) {
            } else {
              this.dataForm.model = ''
            }
          } else {
            this.$alert(res.Message, '错误', {
              confirmButtonText: '确定'
            })
          }
        })
        .catch(function(res) {
          alert(res)
        })
    },
    visibleChange(isVisible) {
      const isEdge = window.navigator.userAgent.includes('Edge')
      if (isEdge && !isVisible) {
        document
          .querySelectorAll('body > .el-select-dropdown.el-popper')
          .forEach(it => it.remove())
      }
    },

    logout: function() {
      sessionStorage.removeItem('user')
      this.$router.push('/login')
    },
    dateFormat: function(row, column) {
      let time = dateFormat(row, column)
      return time
    }
  },
  components: {
    PictureList,
    UploadFile
  },
  mounted() {
    this.getlist()
    this.getDType()
  }
}



// WEBPACK FOOTER //
// ./src/views/Repair/Home.vue